<template>
    <section class="noticias" id="noticias">
        

        <div class="container">
            
            <div class="row">
                <div class="col-8 offset-2 col-md-10 offset-md-1">
                    <img src="/images/noticias-titulo.png" class="titulo" style="max-height: 65px;" />
                </div>
            </div>

            <div class="row">

                <div class="col-10 offset-1  col-md-7 offset-md-1 destaque"> 

                    <div v-if="noticia.Titulo">

                        <router-link :to=" { name : 'noticia', params: { slug: noticia.Link } } ">

                            <img :src="$sdk.prefix_images + noticia.Capa" class="cover" />

                            <h1>{{ noticia.Titulo }}</h1>

                            <div class="html" v-html="noticia.Texto"></div>

                        </router-link>
                    
                    </div>

                </div>

                <div class="col-10 offset-1 col-md-3 sidebar">
                    
                    <main>

                        <div class="noticia" v-for="(noticia, noticiaIndex) in noticias" :key="noticiaIndex">
                            <router-link :to=" { name : 'noticia', params: { slug: noticia.Link } } " @click.native="$router.go()">
                                <div class="thumb" :style="{ 'background-image' : 'url(' + $sdk.prefix_images + noticia.Capa + ')' }">
                                </div>
                                <span>{{ noticia.Titulo }}</span>
                            </router-link>
                        </div>

                    </main>
                    
                </div>

            </div>
        </div>

    </section>
</template>

<script>

var striptags = require('striptags');


export default {
    
    data() {
        return {
            noticia: {},
            noticias: [],
            errorMessage: null,
            s: null
        }
    },

    mounted: function(){

        this.carregar();

    },

    methods: {

        carregar: function(){

            var $this = this;

            $this.$sdk.get('noticias', function(ret){

                if($this.$route.name == 'home'){
                    $this.noticia = ret.shift();
                    $this.noticias = ret;
                
                } else {

                    ret.forEach(noticia => {
                        
                        if(noticia.Link == $this.$route.params.slug)
                            $this.noticia = noticia;
                        else
                            $this.noticias.push(noticia);

                    });

                    


                }

                //trata resumo

                if($this.$route.name == 'home'){
                    $this.noticia.Texto = '<p>' + striptags($this.noticia.Texto) + '</p>';

                    var palavras = $this.noticia.Texto.split(' ');

                    if(palavras.length > 30){

                        $this.noticia.Texto = '';

                        for(var i = 0; i < 30; i++){

                            if($this.noticia.Texto)
                                $this.noticia.Texto += ' ';

                            $this.noticia.Texto += palavras[i];
                        }

                        $this.noticia.Texto += '...';

                    }
                }


            })
        }

    }

}
</script>